import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { getAuth } from '../resources/auth';

class AuthenticatedRoute extends Component {
  render() {
    if (getAuth()) {
      return <Route {...this.props} />;
    }
    return <Redirect to="/"/>;
  }
}

export default AuthenticatedRoute;
